(function () {
  const FEB_DATES = new Set(["2026-03-07","2026-03-08","2026-03-09"]);
  const OPTION_NAME = "Delivery window";       
  const FEB_VALUE = "Marchdelivery";                
  const REG_VALUE = "Regular";                
  const VALENTINE_COLLECTION_URL = "https://flowerpower.ae/collections/womens-day-flowers";
  
  let FEB_SWITCH_IN_PROGRESS = false;

  function norm(s) {
    return String(s || "").replace(/[–—]/g, "-").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function toISODate(value) {
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const m = value.match(/^(\d{1,2})[\/\.-](\d{1,2})[\/\.-](\d{4})$/);
    if (m) return `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d.toISOString().split('T')[0];
  }

  function getSelectedDateISO() {
    const dp = document.querySelector("#datepickerInput");
    if (dp && dp.value) return toISODate(dp.value);

    const checked = document.querySelector('input[name="deliveryDate"]:checked');
if (checked && checked.value) {
  const v = String(checked.value).trim().toLowerCase();

  if (v === "today") {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  }
  if (v === "tomorrow") {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  }

  return toISODate(checked.value);
}


    const allInputs = Array.from(document.querySelectorAll("input"));
    for (let input of allInputs) {
      if (input.value && /(\d{4}-\d{2}-\d{2})|(\d{1,2}[-./]\d{1,2}[-./]\d{4})/.test(input.value)) {
        return toISODate(input.value);
      }
    }
    return null;
  }

  // ====== 3. СТИЛИ И ПОПАПЫ ======
  if (!document.getElementById("feb-popup-styles")) {
    const style = document.createElement("style");
    style.id = "feb-popup-styles";
    style.textContent = `
      .feb-popup-overlay{position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:100000;display:flex;align-items:center;justify-content:center}
      .feb-popup{background:#fff;max-width:450px;width:90%;padding:30px;border-radius:15px;text-align:center;box-shadow:0 10px 40px rgba(0,0,0,0.5);font-family:sans-serif}
      .feb-popup h3{margin:0 0 15px;color:#7b2d3b;font-size:22px}
      .feb-popup ul{text-align:left;margin:15px 0;padding-left:25px;background:#fff5f6;padding:15px;border-radius:10px}
      .feb-popup-actions{display:flex;flex-direction:column;gap:10px;margin-top:20px}
      .feb-btn{padding:12px;border-radius:30px;text-decoration:none;border:none;cursor:pointer;font-weight:bold;display:block}
      .feb-btn-primary{background:#7b2d3b;color:#fff}
      .feb-btn-secondary{background:#f4f4f4;color:#333}
    `;
    document.head.appendChild(style);
  }

  function showFebPopup(badItems) {
    if (document.getElementById("feb-block-popup")) return;
    const popup = document.createElement("div");
    popup.id = "feb-block-popup";
    popup.innerHTML = `
      <div class="feb-popup-overlay">
        <div class="feb-popup">
          <h3>Women’s Day Collection Only</h3>
          <p>On <strong>Feb 13–15</strong>, we only deliver items from the Women’s Day Collection.</p>
          <ul>${badItems.map(i => `<li>${i}</li>`).join("")}</ul>
          <div class="feb-popup-actions">
            <a href="${VALENTINE_COLLECTION_URL}" class="feb-btn feb-btn-primary">Go to Women’s Day Collection</a>
            <button class="feb-btn feb-btn-secondary" onclick="document.getElementById('feb-block-popup').remove()">Close</button>
          </div>
        </div>
      </div>`;
    document.body.appendChild(popup);
  }

  function showFebUnavailablePopup(items) {
    if (document.getElementById("feb-unavailable-popup")) return;
    const popup = document.createElement("div");
    popup.id = "feb-unavailable-popup";
    popup.innerHTML = `
      <div class="feb-popup-overlay">
        <div class="feb-popup">
          <h3>Size Unavailable</h3>
          <p>We’re sorry, this size is not available for the selected dates. Please choose another available size to continue.</p>
          <ul>${items.map(i => `<li>${i}</li>`).join("")}</ul>
          <div class="feb-popup-actions">
            <button class="feb-btn feb-btn-secondary" onclick="document.getElementById('feb-unavailable-popup').remove()">I understand</button>
          </div>
        </div>
      </div>`;
    document.body.appendChild(popup);
  }

  async function reconcileFebPricing() {
    if (FEB_SWITCH_IN_PROGRESS) return;
    const iso = getSelectedDateISO();
    if (!iso) return;

    FEB_SWITCH_IN_PROGRESS = true;
    try {
      const isFeb = FEB_DATES.has(iso);
      const targetValue = isFeb ? FEB_VALUE : REG_VALUE;
      
      const cart = await (await fetch("/cart.js", { credentials: "same-origin" })).json();
      let changed = false;
      let unavailable = [];

      for (const item of cart.items) {
        const domEl = document.querySelector(`[data-cart-item][data-handle="${item.handle}"]`);
        const isValentine = domEl && (domEl.dataset.allowed === "true" || domEl.dataset.allowed === "1");
        if (!isValentine) continue;

        const p = await (await fetch(`/products/${item.handle}.js`, { credentials: "same-origin" })).json();
        const optNames = (p.options || []).map(o => typeof o === "string" ? o : o.name);
        const deliveryIdx = optNames.findIndex(n => norm(n) === norm(OPTION_NAME));
        if (deliveryIdx === -1) continue;

        const currentVar = (p.variants || []).find(v => String(v.id) === String(item.variant_id));
        const getOpt = (v, i) => (v.options || [])[i] ?? v[`option${i + 1}`];

        const targetVar = (p.variants || []).find(v =>
          norm(getOpt(v, deliveryIdx)) === norm(targetValue) &&
          optNames.every((_, i) => i === deliveryIdx || norm(getOpt(v, i)) === norm(getOpt(currentVar, i)))
        );

        if (isFeb && (!targetVar || !targetVar.available)) {
          unavailable.push(item.product_title);
          continue;
        }

        if (targetVar && String(targetVar.id) !== String(item.variant_id)) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ items: [{ id: targetVar.id, quantity: item.quantity, properties: item.properties }] })
          });
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
          changed = true;
        }
      }

      if (unavailable.length > 0) {
        sessionStorage.setItem("feb_unavailable_items", JSON.stringify(unavailable));
      } else {
        sessionStorage.removeItem("feb_unavailable_items");
      }

      if (changed) window.location.reload();
    } catch (err) {
      console.error("Pricing error:", err);
    } finally {
      FEB_SWITCH_IN_PROGRESS = false;
    }
  }

  function checkAndBlock(e) {
    const iso = getSelectedDateISO();
    
    //if (FEB_SWITCH_IN_PROGRESS) {
    //  e.preventDefault(); e.stopImmediatePropagation();
    //  alert("Please wait while we update prices...");
    //  return false;
    //}

    if (!iso || !FEB_DATES.has(iso)) return true;

    const badItems = Array.from(document.querySelectorAll("[data-cart-item]"))
      .filter(el => el.dataset.allowed !== "true" && el.dataset.allowed !== "1")
      .map(el => el.dataset.title || "Item");

    if (badItems.length > 0) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      showFebPopup(badItems);
      return false;
    }

    const stored = sessionStorage.getItem("feb_unavailable_items");
    if (stored) {
      const items = JSON.parse(stored);
      if (items.length > 0) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        showFebUnavailablePopup(items);
        return false;
      }
    }

    return true;
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest('button[name="checkout"], [href*="/checkout"], .checkout-btn')) {
      if (!checkAndBlock(e)) return;
    }

    setTimeout(reconcileFebPricing, 600);
  }, true);

  document.addEventListener("submit", (e) => {
    if (e.target.action && e.target.action.includes("/checkout")) {
      if (!checkAndBlock(e)) e.preventDefault();
    }
  }, true);

window.addEventListener("load", () => {
  const checked = document.querySelector('input[name="deliveryDate"]:checked');
  if (checked) checked.checked = false;

  reconcileFebPricing();
});

})();